// src/components/Banner.js

import React from 'react';
import './Banner.css';
import { Link } from "react-router-dom";
import DishtechVideo from '../video/Dishtech.mp4';
import Reqprodcte from "./Reqprodcte";

const Banner = () => {
    return (
        <section className="banner-container">

            <video autoPlay loop muted playsInline className="banner-video">
                <source src={DishtechVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="banner-content">
                <h1 className="banner-title"> Disha Technologies</h1>
                <p className="banner-subtitle">
                    ENGINEERED FOR YOUR PROFIT</p>
                < p className='powe'>Disha Plastic Machinery</p>
                {/* <button className="banner-buttons"><Link to="/Reqprodcte">Order Now</Link></button> */}
                <div className='req'>
                    <Reqprodcte />
                </div>


            </div>
        </section>
    );
};

export default Banner;
